var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.3335V4.50016C17.25 3.48908 16.4278 2.66683 15.4167 2.66683H13.5833V0.833496H11.75V2.66683H6.25V0.833496H4.41667V2.66683H2.58333C1.57225 2.66683 0.75 3.48908 0.75 4.50016V17.3335C0.75 18.3446 1.57225 19.1668 2.58333 19.1668H15.4167C16.4278 19.1668 17.25 18.3446 17.25 17.3335ZM6.25 15.5002H4.41667V13.6668H6.25V15.5002ZM6.25 11.8335H4.41667V10.0002H6.25V11.8335ZM9.91667 15.5002H8.08333V13.6668H9.91667V15.5002ZM9.91667 11.8335H8.08333V10.0002H9.91667V11.8335ZM13.5833 15.5002H11.75V13.6668H13.5833V15.5002ZM13.5833 11.8335H11.75V10.0002H13.5833V11.8335ZM15.4167 7.25016H2.58333V5.41683H15.4167V7.25016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1899d7a2ddf356b462b7a69247ba4b41.svg";
export { ForwardRef as ReactComponent };